import React, { JSX, ReactNode } from 'react';
import { Flex, Spacer, VStack } from '@chakra-ui/react';

import StepElement from './StepElement';

type RelevosStepsDefaultProps = {
  activeIndex: number;
  children: ReactNode[];
  width?: string | number;
  height?: number | string;
};

export const Stepper = ({ children, activeIndex, width, height }: RelevosStepsDefaultProps): JSX.Element => {
  return (
    <>
      <VStack alignItems="start">
        {children.map((child, index) => (
          <StepElement key={index} index={index} isActive={activeIndex === index} height={height} />
        ))}
      </VStack>
      <Flex direction="column" w={width}>
        {/* FIY: workaround - we will change it to chakra stepper*/}
        {children.map((child, index) => (
          <React.Fragment key={index}>
            {!!index && <Spacer />}
            {child}
          </React.Fragment>
        ))}
      </Flex>
    </>
  );
};

export default Stepper;
